import React, { useEffect, useRef, useState } from 'react'
import { CurrentSession } from '@/services/repository/session'
import { Services } from '@/services/services'
import { isValidIMEI } from '@/common/validators'
import { QRScanner } from '@/components/qr/scanner'
import { useNavigate } from 'react-router-dom'
import { MainLayout, MainPageLayout } from '@/components/layout/MainLayout'

import './scanner.css'
import { BackButton } from '@/components/layout/NavBar'

interface Props { 
  session: CurrentSession 
  services: Services
}

export const UniversalQRScannerBody: React.FC<Props> = ({ services, session }) => {
  const [scannerData, setScannerData] = useState<string>()
  const navigate = useNavigate()
  const currentBaseURL = `${window.location.protocol}//${window.location.host}`

  return <div>
    <QRScanner
      onScan={(data: string) => {
        if (data.startsWith(currentBaseURL)) {
          location.href = data
        }
        setScannerData(data)
      }}
      services={services}
    />
    {scannerData
      ? isValidIMEI(scannerData)
        ? `IMEI: ${scannerData}`
        : null
      : null}
  </div>
}

export const UniversalQRScannerPage: React.FC<Props> = (props) => {
  var { services, session } = props;
  return (
    <MainPageLayout pageName='qr-scanner' {...props} translates={props.session.translates}
        navbarLeft={<BackButton services={services} translates={session.translates} />}>
      <UniversalQRScannerBody {...props} />
    </MainPageLayout>
  )
}